import { render, staticRenderFns } from "./LibAuthFooter.vue?vue&type=template&id=54329092&scoped=true&"
import script from "./LibAuthFooter.vue?vue&type=script&lang=js&"
export * from "./LibAuthFooter.vue?vue&type=script&lang=js&"
import style0 from "./LibAuthFooter.vue?vue&type=style&index=0&id=54329092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54329092",
  null
  
)

export default component.exports